import React from "react";
import { makeStyles } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialogContent-root, .MuiDialogTitle-root": {
      padding: 0,
    },
  },
  content: {
    padding: "32px 24px 24px 24px",
    maxWidth: "500px",
  },
  title: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    marginBottom: "16px",
    "& > h2": {
      fontWeight: "700",
      fontSize: "22px",
      lineHeight: "26px",
      fontFamily: `"Inter", "Inter", "sans-serif"`,
      color: "#000",
    },
  },
  body: {
    textAlign: "center" as const,
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    fontFamily: `"Inter", "Inter", "sans-serif"`,
    margin: 0,
    color: "#555",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "16px",
    marginTop: "32px",
  },
  primaryButton: {
    background: "#EE4360",
    border: "1px solid #EE4360",
    borderRadius: "16px",
    padding: "14px 24px",
    minWidth: "150px",
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "20px",
    textTransform: "initial" as const,
    "&:hover": {
      background: "#FFFFFF",
      border: "1px solid #EE4360",
      color: "#EE4360",
    },
  },
  secondaryButton: {
    borderRadius: "16px",
    border: "1px solid #000",
    padding: "14px 24px",
    minWidth: "150px",
    fontWeight: "bold" as const,
    fontSize: "16px",
    lineHeight: "20px",
    textTransform: "initial" as const,
    background: "#FFFFFF",
    color: "#000",
    "&:hover": {
      background: "#F5F5F5",
    },
  },
});

interface AddressBoxWarningModalProps {
  open: boolean;
  onConfirmAndLeave: () => void;
  onAddAddressBox: () => void;
}

export const AddressBoxWarningModal: React.FC<AddressBoxWarningModalProps> = ({
  open,
  onConfirmAndLeave,
  onAddAddressBox,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={() => {}} // Prevent closing by clicking outside
      aria-labelledby="address-box-warning-dialog"
      className={classes.dialog}
    >
      <Box className={classes.content}>
        <DialogContent>
          <DialogTitle id="address-box-warning-dialog" className={classes.title}>
            Address Box Required
          </DialogTitle>
          <DialogContentText className={classes.body}>
            A Direct Mail format is selected however no address box has been detected.
          </DialogContentText>
        </DialogContent>
        <Box className={classes.buttonContainer}>
          <Button className={classes.secondaryButton} onClick={onConfirmAndLeave}>
            Confirm and Leave
          </Button>
          <Button className={classes.primaryButton} onClick={onAddAddressBox}>
            Add Address Box
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};
